// Preserve addresses and URLs while standardising brand names in dynamic text.
export const normalizeBrand = (text = "") => text.replace(
  /https?:\/\/[^\s]+|[\w.+-]+@[\w.-]+\.[a-z]{2,}|(?:www\.)?eram[\w.-]*\.[a-z]{2,}|\beram(?:\s+(?:digital|holdings))?\b/gi,
  (match) => /[@.:/]/.test(match) ? match : match.toUpperCase()
);
